import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import menu from './menu';
import Router from '@module/router';

import VerticalNav from '@component/navigation/verticalnav';
import I18n from '@module/i18n';
import { consentTracker } from '@module/consent-manager';

import {
  Intro,
  AcceptButton,
  SaveButton,
  RejectButton,
  PurposeList,
  VendorList,
} from '@component/consent-manager';
import { useConsentLanguage } from '../../component/consent-manager/useConsentLanguageHook';
import { isConsentFlagActive } from '@component/consent-manager/flags';

export const ConsentManager = ({ path, language, region }) => {
  const consentLanguage = useConsentLanguage(language);

  useEffect(() => consentTracker.showPanel(), []);

  const handleOnClick = () => {
    Router.navigateTo(Router.getLastRoute('transfer', '/'));
  };

  return (
    <div className="cookie-page legal--cookies row legal">
      <div className="legal__nav-col">
        <VerticalNav
          items={menu(region.country, isConsentFlagActive())}
          activeItem={path}
        />
      </div>

      <div className="consent-manager__container">
        <h1 className="legal__title">
          {I18n.t('transfer.consent-manager.headline')}
        </h1>

        <Intro isInPanel={true}>
          <RejectButton
            onClick={handleOnClick}
            context="panel_intro_preference"
          />
          <AcceptButton
            onClick={handleOnClick}
            context="panel_intro_preference"
          />
        </Intro>

        <div className="consent-manager__consent-preferences">
          <div className="consent-manager__purpose-list">
            <h2 className="legal__subtitle">
              {I18n.t('transfer.consent-manager.preferences-headline')}
            </h2>

            <div
              className="consent-manager__cookie-notice-text"
              dangerouslySetInnerHTML={{
                __html: I18n.t('transfer.consent-manager.preferences-text'),
              }}
            />
            <div
              className="consent-manager__cookie-notice-text"
              dangerouslySetInnerHTML={{
                __html: I18n.t(
                  'transfer.consent-manager.preferences-text-allow-cookies'
                ),
              }}
            />
            <PurposeList consentLanguage={consentLanguage} />
          </div>

          <div className="consent-manager__buttons ">
            <SaveButton
              className={'welcome__button welcome__button--outlined'}
              text={I18n.t('transfer.consent-manager.button-save')}
              onClick={handleOnClick}
              context="panel_purpose_preference"
            />
            <AcceptButton
              onClick={handleOnClick}
              context="panel_purpose_preference"
            />
          </div>

          <h2 className="consent-manager__headline legal__subtitle">
            {I18n.t('transfer.consent-manager.partners-headline')}
          </h2>

          <div
            className="consent-manager__cookie-notice-text"
            dangerouslySetInnerHTML={{
              __html: I18n.t('transfer.consent-manager.partners-text'),
            }}
          />

          <div className="consent-manager__vendor-list">
            <VendorList consentLanguage={consentLanguage} />
          </div>

          <div className="consent-manager__buttons consent-manager__buttons-vendor-list">
            <SaveButton
              className={'welcome__button welcome__button--outlined'}
              text={I18n.t('transfer.consent-manager.button-save')}
              onClick={handleOnClick}
              context="panel_vendor_preference"
            />
            <AcceptButton
              onClick={handleOnClick}
              context="panel_vendor_preference"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ route, session }) => ({
  path: route.path,
  language: session.language,
  region: session.region,
});

export default connect(mapStateToProps)(ConsentManager);

ConsentManager.propTypes = {
  path: PropTypes.string.isRequired,
  language: PropTypes.string,
  region: PropTypes.object,
};
